import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const ConfirmIgDisconnectErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('account_id'),
})

export const ConfirmIgDisconnectGeneralErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('account_channel_disconnect_general'),
})

export const ConfirmIgDisconnectErrorInvalidSignSchema = BusinessErrorSchema.extend({
  field: z.literal('account_channel_disconnect_common_invalid_sign'),
})

export const ConfirmIgDisconnectErrorDisconnectAlreadyInProcessSchema = BusinessErrorSchema.extend({
  field: z.literal('account_channel_disconnect_common_disconnect_already_in_process'),
})

export const ConfirmIgDisconnectErrorChannelIsNotConnectedSchema = BusinessErrorSchema.extend({
  field: z.literal('account_channel_disconnect_common_channel_is_not_connected'),
})

export const ConfirmIgDisconnectErrorInstagramApiErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('account_channel_disconnect_instagram_api_error'),
})
